import {FieldCostItemAppAction, ChangeActions} from "./reducer";
import {connect, Store} from "react-redux";
import {SignupFieldCostItems, RenewFieldCostItems, DataProps, CallbackProps} from "./presentation";
import {isSignupCost, isRenewCost} from "../common/utils";
import {CostItem} from "../standard-items/types";
import {FinancialCodes, PricingOptionState} from "../common/types";

const mapDispatchToFieldItemProps = (dispatch: (a: FieldCostItemAppAction) => FieldCostItemAppAction): CallbackProps => {
	return {
		onFieldProrataPeriodChange: (fieldCostItem, prorataPeriod) => dispatch(ChangeActions.prorataPeriod(fieldCostItem, prorataPeriod)),
	}
}

/**
 * Given a store, search the store for the Standard Cost Item which is matched by the "costChecker" function (e.g.
 * isSignupCost or isRenewCost). Once we have that cost item, figure out if its price is derived from an infoform
 * field, and if so, return the id of that field.
 */
const findInfoformFieldForAnnualCost = (costChecker:(item:CostItem) => boolean, store: PricingOptionState):number => {
	const annualField = store.standardCostItems.items.find(costChecker)
	return annualField !== undefined && annualField.mode == "infoform field" ? annualField.infoformField : 0
}

const canProrata = (store: PricingOptionState, costFinder:(costItem:CostItem) => boolean) => {
	const item = store.standardCostItems.items.find(costFinder)
	return item !== undefined && item.prorataPeriod != null
}

const mapStateToSignupFieldItemProps = (store: PricingOptionState): DataProps => {
	return {
		fields: store.signupFieldCostItems,
		annualCostInfoformField: findInfoformFieldForAnnualCost(isSignupCost, store),
		canProrata: canProrata(store, isSignupCost),
	}
}

const mapStateToRenewFieldItemProps = (store: PricingOptionState): DataProps => {
	return {
		fields: store.renewFieldCostItems,
		annualCostInfoformField: findInfoformFieldForAnnualCost(isRenewCost, store),
		canProrata: canProrata(store, isRenewCost),
	}
}

export type StoreProps = {store:Store<PricingOptionState>, labels: FinancialCodes}

export const SignupFieldItemsContainer = connect<DataProps, CallbackProps, StoreProps, PricingOptionState>(
	mapStateToSignupFieldItemProps,
	mapDispatchToFieldItemProps
)(SignupFieldCostItems)

export const RenewFieldItemsContainer = connect<DataProps, CallbackProps, StoreProps, PricingOptionState>(
	mapStateToRenewFieldItemProps,
	mapDispatchToFieldItemProps
)(RenewFieldCostItems)



// WEBPACK FOOTER //
// ./src/membership3/pricing-option-form/field-items/container.ts